import React from "react";

import { type InstallationScriptDetails } from "@north-beam/nb-common";

import { TrackingScriptCard } from "./tracking-script-card";

interface TrackingScriptTagsProps {
  installationScripts: InstallationScriptDetails;
  startExpanded?: boolean;
}
export const NorthbeamPixelTag = ({
  installationScripts,
  startExpanded,
}: TrackingScriptTagsProps): React.ReactElement => (
  <TrackingScriptCard
    displayName="Northbeam Pixel"
    header={
      "Please place this pixel on every page of your website. This is " +
      "Northbeam's primary pixel."
    }
    scriptCode={installationScripts.northbeam_pixel}
    startExpanded={startExpanded}
    descriptionHTML={
      <>
        <p>
          Please install this script in the <code>head</code> section of every
          page in your website.
        </p>
        <p>
          This pixel needs to be installed on every page of your website. We
          recommend following the Google Tag Manager instructions if you use
          that service.
        </p>
        <ul>
          <li>
            Instructions for Shopify:{" "}
            <a
              href="https://docs.northbeam.io/docs/5-install-the-northbeam-pixel#shopify-instructions"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </li>
          <li>
            Instructions for Google Tag Manager:{" "}
            <a
              href="https://docs.northbeam.io/docs/5-install-the-northbeam-pixel#google-tag-manager-instructions"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </li>
        </ul>
      </>
    }
  />
);
